import {
  STORE_KEY_ACCOUNT,
  evalCondition,
  notifyParent,
  storeGet,
} from 'mailup-react-helpers'

import { offerType } from 'Constants'

export const isEcommerceVisible = (): boolean => {
  const {
    IsRetailer,
    IsDeveloper,
  }: {
    IsRetailer: boolean
    IsDeveloper: boolean
  } = storeGet(STORE_KEY_ACCOUNT)

  const bUserGest: boolean = evalCondition('uo:GEST')
  const bConsoleMshop: boolean = evalCondition('co:TURNOFFMSHOP')

  return !IsRetailer && bUserGest && !IsDeveloper && !bConsoleMshop
}

export const canBuyEngagementFilters = (): boolean => {
  const standardEcomm = isEcommerceVisible()
  const { IdOffer } = storeGet(STORE_KEY_ACCOUNT)

  //  Solo SMS, Starter, Plus, Premium ed enterprise possono acquistare Filtri & Report da MShop
  const validEditions = [
    offerType.Frequenza,
    offerType.SoloSMS,
    offerType.StarterEdition,
    offerType.PlusEdition,
    offerType.PremiumEdition,
    offerType.EnterpriseEdition,
    offerType.LightEdition,
  ]

  return standardEcomm && validEditions.includes(IdOffer)
}

export const openMshopAdditionalOptions = (): void => {
  notifyParent('redirectMainFrame', ['mshop_redirector.aspx?t=mshoppt'])
}

export const openMshopDataSyncImport = (): void => {
  notifyParent('redirectMainFrame', [
    'mshop_redirector.aspx?t=mshopproddet&cp=DataSyncImport',
  ])
}

export const openMshopEngagementReports = (): void => {
  notifyParent('redirectMainFrame', [
    'mshop_redirector.aspx?t=mshopproddet&cp=EngagementReport',
  ])
}

export const openMshopEngagementFilters = (): void => {
  notifyParent('redirectMainFrame', [
    'mshop_redirector.aspx?t=mshopproddet&cp=EngagementFilters',
  ])
}

export const getEngagementDocumentationURL = (lang: string): string => {
  switch (lang) {
    case 'it':
      return 'https://mailup.it/blogs/misurare-engagement/'
    case 'es':
      return 'https://mailup.es/blogs/medir-el-compromiso/'
    default:
      return 'https://mailup.com/blogs/measure-engagement/'
  }
}

export const hasMShop = (): boolean => {
  return evalCondition(
    'uo:GEST AND NOT c:IsRetailer AND NOT c:IsDeveloper AND NOT co:TURNOFFMSHOP',
  ) as boolean
}
